/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Dok_TInputs */

const en_tut_dok_t = /** @type {(inputs: Tut_Dok_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents: write, review, export`)
};

const id_tut_dok_t = /** @type {(inputs: Tut_Dok_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen: menulis, meninjau, mengunduh`)
};

/**
* | output |
* | --- |
* | "Documents: write, review, export" |
*
* @param {Tut_Dok_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_dok_t = /** @type {((inputs?: Tut_Dok_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Dok_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_dok_t(inputs)
	return en_tut_dok_t(inputs)
});